import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Plus, X } from 'lucide-react';
import { ImageUrlInput } from './ImageUrlInput';

export interface CreatorEntryItem {
  imageUrl: string;
  name: string;
  username: string;
  views: string;
  likes: string;
  link?: string;
}

interface CreatorEntriesInputProps {
  value?: CreatorEntryItem[];
  onChange: (_value: CreatorEntryItem[]) => void;
}

export const CreatorEntriesInput: React.FC<CreatorEntriesInputProps> = ({
  value = [],
  onChange,
}) => {
  const [items, setItems] = useState<CreatorEntryItem[]>(value);

  useEffect(() => {
    setItems(value);
  }, [value]);

  const add = () => {
    const next = [...items, { imageUrl: '', name: '', username: '', views: '', likes: '' }];
    setItems(next);
    onChange(next);
  };

  const remove = (index: number) => {
    const next = items.filter((_, i) => i !== index);
    setItems(next);
    onChange(next);
  };

  const update = (index: number, field: keyof CreatorEntryItem, val: string) => {
    const next = items.map((item, i) =>
      i === index ? { ...item, [field]: val } : item
    );
    setItems(next);
    onChange(next);
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-end">
        <Button type="button" variant="outline" size="sm" onClick={add} className="gap-2">
          <Plus className="w-4 h-4" />
          Adicionar creator
        </Button>
      </div>
      {items.length === 0 ? (
        <div className="text-center py-4 text-gray-500 text-sm border-2 border-dashed border-gray-200 rounded-lg">
          Nenhum creator adicionado
        </div>
      ) : (
        <div className="space-y-4">
          {items.map((item, index) => (
            <div key={index} className="border border-gray-200 rounded-lg p-4 bg-white space-y-2">
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium text-gray-700">Creator {index + 1}</span>
                <Button
                  type="button"
                  variant="outline"
                  size="sm"
                  onClick={() => remove(index)}
                  className="text-red-500 hover:text-red-700 hover:bg-red-50"
                >
                  <X className="w-4 h-4" />
                </Button>
              </div>
              <ImageUrlInput
                placeholder="URL da foto"
                value={item.imageUrl}
                onChange={(url) => update(index, 'imageUrl', url)}
              />
              <div className="grid grid-cols-2 gap-2">
                <Input
                  placeholder="Nome"
                  value={item.name}
                  onChange={(e) => update(index, 'name', e.target.value)}
                />
                <Input
                  placeholder="Username (ex: pedrodecarvalho)"
                  value={item.username}
                  onChange={(e) => update(index, 'username', e.target.value)}
                />
              </div>
              <div className="grid grid-cols-2 gap-2">
                <Input
                  placeholder="Views (ex: 359M views)"
                  value={item.views}
                  onChange={(e) => update(index, 'views', e.target.value)}
                />
<Input
                placeholder="Likes (ex: 548k likes)"
                  value={item.likes}
                  onChange={(e) => update(index, 'likes', e.target.value)}
                />
              </div>
              <Input
                placeholder="Link (URL do perfil ou vídeo)"
                value={item.link ?? ''}
                onChange={(e) => update(index, 'link', e.target.value)}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
